/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarContact_viewer$ref: FragmentReference;
export type PdpRespSidebarContact_viewer = {|
  +isContactSupportEnabled: ?boolean,
  +isMessageCenterEnabled: ?boolean,
  +$refType: PdpRespSidebarContact_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isContactSupportEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CONTACT_1STDIBS",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5f542e28d69328d74872b388d9d80215';
module.exports = node;
